<script>  
    import {
        Icon
    } from "sveltestrap"
    import twemoji from 'twemoji';

    import { _ } from 'svelte-i18n';

    import { useQuery } from '@sveltestack/svelte-query'
    const profilData = useQuery("profilData")
</script>

<style>
    :global(img.emoji) {
        height: 1em;
        width: 1em;
        margin: 0 .05em 0 .1em;
        vertical-align: -0.1em;
    }
</style>

{#key $profilData}
    <h4>{$profilData.data.name}, {$profilData.data.age} ans, 
        {#if $profilData.data.gender == "F"}
            <span title={$_("components.ProfilNameDescAge.Woman")}>{@html twemoji.parse("♀️")}</span>
        {:else if $profilData.data.gender == "M"}
            <span title="{$_("components.ProfilNameDescAge.Man")}">{@html twemoji.parse("♂️")}</span>
        {/if}
    </h4>
    {#if $profilData.data.description}
        <p class="mt-3">
            {@html twemoji.parse($profilData.data.description)}
        </p>
    {/if}
{/key}